export default "__VITE_ASSET__DCMHCoSw__"